module.exports = __webpack_public_path__ + "media/src/images/progress/dentals_1-3b793a8637a46889c609bfb2a69f9a19.jpg";